export default __webpack_public_path__ + "media/shalanaVid.272355e5.mp4";